import { z } from 'zod';
import { BILLING_INTERVAL_SCHEMA } from '../billing-interval/billing-interval.ts';
import { LINE_ITEM_TYPE_SCHEMA } from '../events/item-fulfillment-event-payload.ts';
import { SUPPORTED_UNITS_SCHEMA } from '../quote-unit/unit-types.ts';
import { PRODUCT_TYPE_SCHEMA } from '../product-type/product-types.ts';
import { PRODUCT_CATEGORY_SCHEMA } from '../order-product/product-category.ts';
import { POSITION_PRODUCT_STATUS_SCHEMA } from './position-quote-status.ts';

export const PositionLineItemSchema = z.object({
    positionProductId: z.string().uuid(),
    unit: SUPPORTED_UNITS_SCHEMA,
    sflxPlatformId: z.number(),
    quantity: z.number().nonnegative(),
    salesPrice: z.number(),
    currencyCode: z.string().length(3),
    name: z.string(),
    productType: PRODUCT_TYPE_SCHEMA,
    productCategory: PRODUCT_CATEGORY_SCHEMA,
    creditorOrganizationId: z.number(),
    creditorCostCenter: z.string().optional(),
    debtorOrganizationId: z.number(),
    debtorCostCenter: z.string().optional(),
    taxClassId: z.string(),
    unitPriceAmount: z.number(),
    type: LINE_ITEM_TYPE_SCHEMA,
    billingInterval: BILLING_INTERVAL_SCHEMA.nullish(),
    status: POSITION_PRODUCT_STATUS_SCHEMA,
    supportingDocuments: z
        .array(
            z.object({
                description: z.string(),
                url: z.string().url(),
            })
        )
        .optional(),
});

export type PositionLineItem = z.infer<typeof PositionLineItemSchema>;

export const GetPositionLineItemsResponseSchema = z.array(PositionLineItemSchema);

export type GetPositionLineItemsResponse = z.infer<typeof GetPositionLineItemsResponseSchema>;
